import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters({
      motorOption: 'preference/getMotorOption'
    }),
  },
  methods: {
    /**
     * @param powerPackTypes String or Array
     * @returns {boolean}
     */
    canShowModule(powerPackTypes) {
      if(typeof powerPackTypes === 'string') {
        powerPackTypes = [powerPackTypes];
      }

      return powerPackTypes.includes(this.motorOption);
    }
  }
}
